const Workshop = () => {
  return <div className="m-3">Coming soon...</div>;
};

export default Workshop;
